import AppError from './AppError';

export default class DuplicateFolderNamesError extends AppError {
	constructor() {
		super( { name: 'DuplicateFolderNamesError' } );
	}
}
